import { Dvr, Info, People } from "@mui/icons-material";
import {
  BottomNavigation,
  BottomNavigationAction,
  createTheme,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import { yellow } from "@mui/material/colors";
import { Box, ThemeProvider } from "@mui/system";
import { useEffect, useState } from "react";
import { AboutPage } from "./pages/about_page";
import { CharactersPage } from "./pages/characters_page";
import { EpisodesPage } from "./pages/episodes_page";
import { WelcomePage } from "./pages/welcome_page";

const ParivaarTwistTheme = createTheme({
  palette: {
    secondary: {
      main: yellow[700],
    },
  },
});

const App: React.FC = () => {
  const [path, setPath] = useState(window.location.hash.slice(1));

  useEffect(() => {
    // Load correct page if browser history is navigated
    window.onpopstate = function (event) {
      setPath(window.location.hash.slice(1));
    };
  }, []);

  useEffect(() => {
    // Change address bar
    if (!window.location.hash.includes(path)) window.location.hash = path;
  }, [path]);

  return (
    <>
      <ThemeProvider theme={ParivaarTwistTheme}>
        <Box
          display="flex"
          justifyContent="center"
          paddingBottom={7}
          maxWidth={900}
          margin={"auto"}
        >
          {getPageContent()}
          {getPageFooter()}
        </Box>
      </ThemeProvider>
    </>
  );

  function getPageContent(): React.ReactNode {
    switch (path) {
      case "/characters":
        return <CharactersPage />;
      case "/episodes":
        return <EpisodesPage />;
      case "/about":
        return <AboutPage />;
      case "/print":
        return (
          <Stack direction={"column"}>
            <CharactersPage />
            <Box height={200} />
            <Typography paddingLeft={1} variant="button" fontWeight={"bold"}>
              Episodes
            </Typography>
            <EpisodesPage />
          </Stack>
        );
      case "/welcome":
      default:
        return <WelcomePage onConfirm={() => setPath("/characters")} />;
    }
  }

  function getPageFooter(): React.ReactNode {
    return (
      <>
        <Paper
          sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 9 }}
          elevation={3}
        >
          <BottomNavigation
            showLabels
            value={path}
            onChange={(event, newValue: string) => setPath(newValue)}
          >
            <BottomNavigationAction
              value={"/characters"}
              label="Characters"
              icon={<People />}
            />
            <BottomNavigationAction
              value={"/episodes"}
              label="Episodes"
              icon={<Dvr />}
            />
            <BottomNavigationAction
              value={"/about"}
              label="About"
              icon={<Info />}
            />
          </BottomNavigation>
        </Paper>
      </>
    );
  }
};

export default App;
